import {defaultConfiguration, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_AUCHAN_UA: IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443'
  },
  theme: 'auchan',
  language: {
    defaultLang: 'ua',
    showLang: true,
    langList: ['ru', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login: {
      ...defaultConfigurationModules.login,

      loginType: 'common',
      goFAQ: '',
      supportEmail: 'negoce_extranet@auchan.ua',
      enableSelfRegistration: false,
      enableGoogleSignIn: false,

      showTutorialVideo: false,
      showTryDemoButton: false,
      showAboutUsButton: false,
      showContacts: true,
      showContactOnlyEmail: true,

      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main: {
      showSupportBlock: false,
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showSuppliersCodeForPartner: true,

    }
  }
};


export const CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_UA,
  api: {
    ...CONFIGURATION_AUCHAN_UA.api,
    protocol: 'http',
    port: '80'
  },
  auth: {
    realm: 'auchan_ua',
    module: 'ad'
  },
  header: {
    ...CONFIGURATION_AUCHAN_UA.header,
    userInfoComponents: [

      {className: 'app-user-info-detail-separator', parameters: null},
      {className: 'app-user-info-detail-version-info', parameters: null},
      {className: 'app-user-info-detail-login-info', parameters: null},
      {className: 'app-user-info-detail-email-info', parameters: null},
      {className: 'app-user-info-detail-user-name-info', parameters: null},

      {className: 'app-user-info-detail-separator', parameters: null},
      {className: 'app-user-info-detail-my-company-info', parameters: null},
      {className: 'app-user-info-detail-user-role-info', parameters: null},

      {className: 'app-user-info-detail-separator', parameters: null},
      {className: 'app-user-info-detail-logout-button', parameters: null}


    ]
  },
  pagesConfig: {
    ...CONFIGURATION_AUCHAN_UA.pagesConfig,
    login: {
      ...CONFIGURATION_AUCHAN_UA.pagesConfig.login,
      enableRestorePassword: false

    }
  }
};
export const CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_UA,
  api: {
    ...CONFIGURATION_AUCHAN_UA.api,
    protocol: 'http',
    port: '80'
  },
  auth:{
    realm: 'auchan_ua',
    module: 'ldap'
  }
};
export const CONFIGURATION_AUCHAN_UA_CLIENT_EXTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_UA,
  auth:{
    realm: 'auchan_ua',
    module: 'ldap'
  }
};

export const CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL_TEST:IConfiguration = {
  ...CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL,
  api: {
    ...CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL.api,
    port: '8081'
  }
};

export const CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL_TEST:IConfiguration = {
  ...CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL,
  api: {
    ...CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL.api,
    port: '8081'
  }
};
